
import { Component } from '@angular/core';
import { HistoryItemResponse, MessageContent } from '@shared/index';
import dayjs from 'dayjs';
import { BotMessagesService } from '../../services/bot-messages.service';
import { DownloadManagerService } from '../../services/download-manager.service';
import { EventManagerService } from '../../services/event-manager/event-manager.service';
import { SocketService } from '../../services/socket.service';

@Component({
  selector: 'app-disconnect-overlay',
  imports: [],
  templateUrl: './disconnect-overlay.component.html',
  styleUrl: './disconnect-overlay.component.scss'
})
export class DisconnectOverlayComponent {
  protected showOverlay = false;
  constructor(
    public socketService: SocketService,
    private downloadManager: DownloadManagerService,
    private botMessages: BotMessagesService,
    private eventManager: EventManagerService
  ) {
    this.socketService.onDisconnect.subscribe((status) => {
      this.eventManager._trigger_RAGAI_EVENT('RAGAI.INFO.disconnected', 'Bot disconnected');
      this.showOverlay = !status;
    });
    // The socket may reconnect on its own (exponential backoff, or an
    // immediate retry triggered by the Page Visibility API) — without this,
    // the overlay stayed stuck forever after any disconnect, even a
    // transient one, forcing users to reload manually.
    this.socketService.onReconnected.subscribe(() => {
      this.showOverlay = false;
    });
  }

  public refresh() {
    window.location.reload();
  }

  public saveChat() {
    const chat = this.botMessages.getMessages()
      .filter((message) => this.isMessageVisibleInChat(message))
      .map((message) =>
        `${message.role} (${dayjs(message.created).format('YYYY-MM-DDTHH:mm:ssZ')})\n${this.getMessageContent(message.content)}`
      )
      .join('\n\n');
    this.downloadManager.textAsFile(chat, 'chatverlauf.txt');
  }

  private isMessageVisibleInChat(message: HistoryItemResponse): boolean {
    const firstContent = message.content.at(0);
    if (!firstContent) {
      return false;
    }

    if (firstContent.type === 'mcp_approval_request') {
      return false;
    }

    if (message.bypass) {
      return false;
    }

    return firstContent.type === 'text' && firstContent.text.trim() !== '';
  }

  private formatMcpApprovalRequest(content: MessageContent & { type: 'mcp_approval_request'; }): string {
    const toolName = typeof content.name === 'string' ? content.name : 'Unbekanntes Tool';
    const serverLabel = typeof content.server_label === 'string' && content.server_label.trim() !== ''
      ? ` (${content.server_label})`
      : '';
    const args = typeof content.arguments === 'string' && content.arguments.trim() !== ''
      ? `\nArgumente: ${content.arguments}`
      : '';

    return `MCP-Approval-Request: ${toolName}${serverLabel}${args}`;
  }

  private getMessageContent(content: MessageContent[]) {
    const msg = content.at(0);
    if (!msg) {
      return '';
    }

    if (msg.type === 'text') {
      return msg.text;
    }

    if (msg.type === 'mcp_approval_request') {
      return this.formatMcpApprovalRequest(msg);
    }

    return '';
  }
}
